import Marquee from "react-fast-marquee";

const items = [
  "Sunday Picnics",
  "Coffee Brewing",
  "Pizza Making",
  "Perfume Labs",
  "Sound Baths",
  "Vineyard Walks",
  "Sunrise Treks",
  "Pottery Circles",
];

export const BrandMarquee = () => (
  <div data-testid="brand-marquee" className="bg-ochre border-y border-ink/10 py-6">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-4xl text-ink px-8">{t}</span>
          <span className="text-ink/50 text-2xl">&bull;</span>
        </span>
      ))}
    </Marquee>
  </div>
);
